module.exports = __webpack_public_path__ + "img/jobs.e68a5338.svg";